"use client"

import React, { useEffect } from "react"

import useWistiaScripts from "@/hooks/useWistiaScripts"

interface WistiaLegacyPopoverProps {
  videoId: string
  className?: string
  aspectRatio?: string // Allows customizable aspect ratio
}

export default function WistiaLegacyPopover({
  videoId,
  className,
  aspectRatio = "56.25%", // Default to 16:9 aspect ratio
}: WistiaLegacyPopoverProps) {
  const scriptsLoaded = useWistiaScripts()

  useEffect(() => {
    if (!scriptsLoaded) return

    // Only load the JSONP script after main Wistia scripts are loaded
    const jsonpScriptId = `wistia-jsonp-${videoId}`
    if (!document.getElementById(jsonpScriptId)) {
      const jsonpScript = document.createElement("script")
      jsonpScript.src = `https://fast.wistia.com/embed/medias/${videoId}.jsonp`
      jsonpScript.async = true
      jsonpScript.id = jsonpScriptId
      document.body.appendChild(jsonpScript)
    }
  }, [videoId, scriptsLoaded])

  // Show loading state while scripts are loading
  if (!scriptsLoaded) {
    // TODO: add loading state
    return null
  }

  return (
    <div
      className={`wistia_responsive_padding ${className || ""}`}
      style={{
        padding: `${aspectRatio} 0 0 0`, // Responsive padding
        position: "relative",
      }}
    >
      <div
        className="wistia_responsive_wrapper"
        style={{
          height: "100%",
          left: 0,
          position: "absolute",
          top: 0,
          width: "100%",
        }}
      >
        <span
          className={`wistia_embed wistia_async_${videoId} popover=true videoFoam=true`}
          style={{
            display: "inline-block",
            height: "100%",
            position: "relative",
            width: "100%",
          }}
        >
          &nbsp;
        </span>
      </div>
    </div>
  )
}
